import React from "react";
import { styled } from "@mui/styles";

import {
    Box,
    Card as MuiCard,
    CardContent as MuiCardContent,
    Chip as MuiChip,
    Typography as MuiTypography
} from "@mui/material";

import { spacing } from "@mui/system";

const Typography = styled(MuiTypography)(spacing);

const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)(({ theme }) => ({
    position: 'relative',
    '&:last-child': {
        paddingBottom: theme.spacing(4)
    }
}));

const Chip = styled(MuiChip)(({ theme }) => ({
    position: 'absolute',
    top: '16px',
    right: '16px',
    height: '20px',
    padding: '4px 0',
    fontSize: '85%',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    marginBottom: theme.spacing(4),
    '& span': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    }
}));

const Percentage = styled(MuiTypography, {
    shouldForwardProp: (prop) => prop !== "percentagecolor"
})(({ percentagecolor, theme }) => ({
    color: theme.palette.grey[600],

    '& span': {
        color: percentagecolor,
        paddingRight: '10px',
        fontWeight: theme.typography.fontWeightBold
    }
}));

const StatsCard = ({ title, amount, chip, percentageText, percentagecolor, comparison }) => {
    return (
        <Card mb={3} style={{ height: '100%' }}>
            <CardContent>
                <Typography variant="h6" mb={6}>
                    {title}
                </Typography>
                <Typography variant="h3" mb={6}>
                    <Box fontWeight="fontWeightRegular">{amount}</Box>
                </Typography>
                <Percentage variant="subtitle1" mb={6} percentagecolor={percentagecolor}>
                    <span>{percentageText}</span>&nbsp;{comparison}
                </Percentage>
                <Chip label={chip} />
            </CardContent>
        </Card>
    );
}

export default StatsCard;
